<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <div class="pending-action-bar">
    <div class="pending-action-message">
      <span class="pending-action-icon">{{ icon }}</span>
      <oxd-text tag="span">{{ message }}</oxd-text>
      <oxd-text v-if="secondary" tag="span" class="pending-action-secondary">
        ({{ secondary }})
      </oxd-text>
    </div>
    <oxd-button
      display-type="secondary"
      size="small"
      :label="actionLabel"
      :disabled="disabled"
      @click="$emit('action')"
    />
  </div>
</template>

<script>
export default {
  name: 'PendingActionBar',

  props: {
    message: {
      type: String,
      required: true,
    },
    secondary: {
      type: String,
      default: '',
    },
    actionLabel: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '🕓',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['action'],
};
</script>

<style lang="scss" scoped>
.pending-action-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0.6rem 0.85rem;
  border-radius: 4px;
  border: 1px solid #f0a30a;
  background-color: rgba(240, 163, 10, 0.12);
}

.pending-action-message {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.8rem;
}

.pending-action-icon {
  font-size: 1rem;
}

.pending-action-secondary {
  font-style: italic;
  opacity: 0.75;
}
</style>
